import { axios, baseURL } from '@axios'
import encryptionService from '@/services/encryption.service'
import { DirectUpload } from '@rails/activestorage'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchEvents(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/events', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchInvites(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/events/invites', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchRequests(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/events/requests', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchUpcomingLeaves(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/events/upcoming_leaves', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCompanyEvents(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/events/company_events', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchBlockedDates(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/events/blocked_dates', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchLeaveSummary(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/events/summary', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchBalances(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/users/balances', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchEventLogs(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/event_logs', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchNotifications(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/notifications', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchEvent(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/events/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateEvent(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/events/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateUserBranch(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/users/${params.id}/update_branch`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    voidEvent(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/events/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createEvent(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('/api/v1/events', { event: params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchEventTypes() {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/variables/event_types')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchLeaveTypes() {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/variables/leave_types')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchLeaveBalance() {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/variables/leave_balance')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchInvoiceReminder(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/invoices/reminder', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateInviteStatus(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`/api/v1/events/${params.id}/update_invite_status`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateRequestStatus(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`/api/v1/events/${params.id}/update_request_status`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    directUploadMC(ctx, file) {
      return new Promise((resolve, reject) => {
        const url = `${baseURL}/direct_uploads?referer=mc`
        const upload = new DirectUpload(file, url, {
          directUploadWillCreateBlobWithXHR: xhr => {
            const authHeaders = JSON.parse(encryptionService.decrypt(localStorage.getItem('authHeaders')))
            if (authHeaders) {
              xhr.setRequestHeader('access-token', authHeaders.accessToken)
              xhr.setRequestHeader('token-type', authHeaders.tokenType)
              xhr.setRequestHeader('client', authHeaders.client)
              xhr.setRequestHeader('expiry', authHeaders.expiry)
              xhr.setRequestHeader('uid', authHeaders.uid)
            }
          },
        })

        upload.create((error, blob) => {
          if (error) reject(error)
          else resolve(blob)
        })
      })
    },
    markAsRead(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('/api/v1/notifications/read', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
